﻿'use strict';

/**
 * @ngdoc overview
 * @name route
 * @description
 * # route
 *
 * Application Routing.
 */

angular.module('ntmApp').config(['$routeProvider', '$httpProvider', '$locationProvider', function ($routeProvider, $httpProvider, $locationProvider) {
    //$qProvider.errorOnUnhandledRejections(false);
    $httpProvider.interceptors.push(['$q', '$rootScope', function ($q, $rootScope) {
        return {
            'request': function (config) {
                var expiration = $rootScope.globals.currentUser ? new Date($rootScope.globals.currentUser.expiredDate) : null; // Do not remove. Removing usage of expiredDate here and in route.js somehow breaks Left Navigation Menu and Grid functionalities.
                var date = new Date();
                if (!$rootScope.globals.currentUser || !config.headers.Bearer || config.url.indexOf('src') > -1 || config.url === '/api/Account/Refresh' || new Date(expiration.getTime()) > date) {
                    return config;
                }

                var data = {};
                var deferred = $q.defer();

                if ($rootScope.requests.length > 0) {
                    $rootScope.requests.forEach(function (item) {
                        if (item.url !== config.url && item.method !== config.method) {
                            $rootScope.requests.push(config);
                        }
                    });
                } else {
                    $rootScope.requests.push(config);
                }

                data.AccessToken = $rootScope.globals.currentUser.token;
                // data.RefreshToken = $rootScope.globals.currentUser.refreshToken;
                /*if (!$rootScope.refreshing) {
                    $rootScope.refreshing = true;
                    http.post('/api/Account/Refresh', data).success(function (result) {
                        $rootScope.refreshing = false;
                        if (result.token && result.refreshToken && result.expiresUtc) {
                            $rootScope.globals.currentUser.token = result.token;
                            $rootScope.globals.currentUser.refreshToken = result.refreshToken;
                            $rootScope.globals.currentUser.expiredDate = result.expiresUtc;
                            $injector.get("$http").defaults.headers.common['Bearer'] = result.token; // jshint ignore:line
                            $cookieStore.put('globals', $rootScope.globals);
                            config.headers.Bearer = result.token;
                            $rootScope.requests.forEach(function (item) {
                                item.headers.Bearer = result.token;
                                http(item);
                            });
                        }
                        deferred.resolve(config);
                    }).error(function () {
                        $rootScope.globals = null;
                        $cookieStore.put('globals', $rootScope.globals);
                        $location.path('/login');
                    });
                }*/

                return deferred.promise;
            }
        };
    }]);
    $routeProvider
        .when('/home', {
            controller: 'HomeController',
            templateUrl: 'ng1/src/home/homeView.html'
        })

        .when('/calendar/:id', {
            controller: 'CalendarController',
            templateUrl: 'ng1/src/calendar/views/calendarView.html'
        })

        .when('/dailyPlan', {
            controller: 'DailyPlanController',
            templateUrl: 'ng1/src/dailyPlan/views/dailyPlanView.html',
            reloadOnSearch: false
        })

        .when('/dashboard/:id', {
            controller: 'DashboardController',
            templateUrl: 'ng1/src/dashboard/views/view.html'
        })

        .when('/forecast', {
            controller: 'ForecastOptionsController',
            templateUrl: 'ng1/src/staffForecasting/forecastOptionsView.html'
        })

        .when('/currentForecast', {
            controller: 'ForecastController',
            templateUrl: 'ng1/src/staffForecasting/forecastView.html'
        })

        .when('/forecastScenario/:scenarioId', {
            controller: 'ForecastScenarioController',
            templateUrl: 'ng1/src/staffForecasting/forecastView.html'
        })

        .when('/grid/listGrid/:id/:grid', {
            controller: 'ListGridController',
            templateUrl: 'ng1/src/setup/views/listGridView.html'
        })

        .when('/grid/profile/:id/:grid', {
            controller: 'ProfileController',
            templateUrl: 'ng1/src/setup/views/profileView.html',
            reloadOnSearch: false
        })

        .when('/login', {
            template: '<login></login>'
        })

        .when('/page/:id', {
            controller: 'GeneralPageController',
            templateUrl: 'ng1/src/generalPages/views/generalPageView.html'
        })

        .when('/reports/:id/', {
            controller: 'ReportsPageController',
            templateUrl: 'ng1/src/reports/reportsPageView.html'
        })

        .when('/searches/:id', {
            controller: 'SearchesController',
            templateUrl: 'ng1/src/searches/searchesView.html'
        })

        .when('/scenarioGenerator', {
            controller: 'ScenarioGeneratorController',
            templateUrl: 'ng1/src/scenarioGenerator/scenarioGeneratorView.html'
        })

        .when('/todaysAssignments/preparationList/:facilityId?/:roomId?', {
            controller: 'preparationListController',
            templateUrl: 'ng1/src/todaysAssignments/preparationListView.html'
        })

        .when('/todaysAssignments/roomRackCensus/:facilityId/:roomId', {
            controller: 'RoomRackCensusController',
            templateUrl: 'ng1/src/todaysAssignments/roomRackCensusView.html'
        })

        .when('/todaysAssignments/activity/:scheduleId', {
            controller: 'ActivityDetailsController',
            templateUrl: 'ng1/src/todaysAssignments/activityDetailsView.html'
        })

        .when('/todaysAssignments/activity', {
            controller: 'ActivityDetailsController',
            templateUrl: 'ng1/src/todaysAssignments/activityDetailsView.html'
        })

        .when('/todaysAssignments/room/:facilityId/:roomId', {
            controller: 'RoomDetailsController',
            templateUrl: 'ng1/src/todaysAssignments/roomDetailsView.html'
        })

        .when('/todaysAssignments', {
            controller: 'TodaysAssignmentsController',
            templateUrl: 'ng1/src/todaysAssignments/todaysAssignmentsView.html'
        })

        .when('/preview/:id', {
            template: '<preview-balance></preview-balance>'
        })

        

        .otherwise({ redirectTo: '/home' });

        $locationProvider.html5Mode(true);
  }]);